import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
//modules
import authentication from "./modules/authentication.js";
import system from "./modules/system.js";
import app from "./modules/app.js";
import rateLimiting from "./modules/rateLimiting.js";
import assistant from "./modules/assistant.js";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		authentication,
		system,
		app,
		rateLimiting,
		assistant,
	},
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
			// Don't persist rate limiting state across sessions
			paths: ["authentication", "system", "app"],
		}),
	],
});
